/* eslint-disable */

(function (f) { if (typeof exports === 'object' && typeof module !== 'undefined') { module.exports = f(); } else if (typeof define === 'function' && define.amd) { define([], f); } else { let g; if (typeof window !== 'undefined') { g = window; } else if (typeof global !== 'undefined') { g = global; } else if (typeof self !== 'undefined') { g = self; } else { g = this; }g.Track = f(); } })(() => {
    let define, module, exports; return (function () { function r(e, n, t) { function o(i, f) { if (!n[i]) { if (!e[i]) { const c = typeof require == 'function' && require; if (!f && c) return c(i, !0); if (u) return u(i, !0); const a = new Error('Cannot find module \'' + i + '\''); throw a.code = 'MODULE_NOT_FOUND', a; } const p = n[i] = {exports: {}}; e[i][0].call(p.exports, r => { const n = e[i][1][r]; return o(n || r); }, p, p.exports, r, e, n, t); } return n[i].exports; } for (var u = typeof require == 'function' && require, i = 0; i < t.length; i++)o(t[i]); return o; } return r; })()({1: [function (require, module, exports) {
        const util = require('../util/geoutil.js');

        module.exports = Point;

        function Point(latitude, longitude, elevation, time, hdop, vdop, speed, course) {

            //console.log(latitude + " " + longitude + " " + elevation + " " + time)
            this.latitude = latitude;
            this.longitude = longitude;
            this.elevation = elevation;
            this.time = time;

            if (arguments.length > 4) {
                this.hdop = hdop;
                this.vdop = vdop;
                this.speed = speed;
                this.course = course;
            }
            this.distanceFromStart = 0;
        }

        Point.prototype.latlng = function () {
            return [this.latitude, this.longitude];
        };

        Point.prototype.array3d = function () {
            return [this.longitude, this.latitude, this.elevation];
        };

        Point.prototype.array4d = function () {
            return [this.longitude, this.latitude, this.elevation, this.time];
        };

        Point.prototype.inspect = function () {
            return `Lat: ${  this.latitude  }  Lon: ${  this.longitude}`;
        };

        Point.prototype.distanceTo = function (point) {
            return util.haversineDistance(this.latitude, this.longitude, point.latitude, point.longitude);
        };

        Point.prototype.getJson = function () {
            const dict = {};
            dict['latitude'] = this.latitude;
            dict['longitude'] = this.longitude;
            dict['elevation'] = this.elevation;
            dict['time'] = new Date((this.time * 1000)).toISOString();
            return dict;
        };

        Point.prototype.dateString = function () {
            return new Date((this.time * 1000)).toISOString();
        };

    }, {'../util/geoutil.js': 5}], 2: [function (require, module, exports) {
        const util = require('../util/geoutil.js');
        const simplifylib = require('../util/simplify.js');
        const DoubleBuffer = require('../util/doublebuffer.js');

        const ELEVATION_CHANGE_THRESHOLD = 2;
        const STOPPED_TIME_SPEED_THRESHOLD = 0.12;
        const MIN_ELEVATION = -999;
        const MAX_ELEVATION = 99999;

        module.exports = TrackSegment;

        function TrackSegment() {
            this.points = [];

            // Absolute Stats
            this.distance = 0;
            this.totalTime = 0;
            this.stoppedTime = 0;
            this.maxSpeed = 0;
            this.maxElevation = null;
            this.minElevation = null;
            this.elevationGain = 0;
            this.elevationLoss = 0;
            this.startTime = null;

            this.maxLatitude = null;
            this.maxLongitude = null;
            this.minLatitude = null;
            this.minLongitude = null;

            this.lastPoint = null;
            this.recording = false;

            this.smoothElevations = [];
            this.maxSmoothElevation = null;
            this.minSmoothElevation = null;
            this.smoothGain = 0;
            this.smoothLoss = 0;

            this.lastElevationUsed = null;
        }


        // Put computations here that are performed after the whole track is read in
        TrackSegment.prototype.calculateStats = function () {
            this.calculateSmoothElevations();
        };


        TrackSegment.prototype.trackTime = function () {
            if (this.recording) {
                return (new Date()).getTime() - this.startTime;
            }
            return this.totalTime;
        };

        TrackSegment.prototype.addPoints = function (points) {
            points.forEach(function (point) {
                this.addPoint(point);
            }, this);
        };

        TrackSegment.prototype.addPoint = function (point) {
            this.points.push(point);
            if (this.lastPoint === null) {
                this.lastPoint = point;
                this.startTime = point.time;
                this.minElevation = point.elevation;
                this.maxElevation = point.elevation;
                this.minSmoothElevation = point.elevation;
                this.maxSmoothElevation = point.elevation;
                this.maxLatitude = point.latitude;
                this.minLatitude = point.latitude;
                this.maxLongitude = point.longitude;
                this.minLongitude = point.longitude;

                this.lastElevationUsed = point.elevation;
                return;
            }

            const newDistance = this.lastPoint.distanceTo(point);
            this.distance = this.lastPoint.distanceFromStart + newDistance;
            point.distanceFromStart = this.distance;
            this.totalTime = point.time - this.startTime;

            const elevationDelta = point.elevation - this.lastElevationUsed;

            if (Math.abs(elevationDelta) > ELEVATION_CHANGE_THRESHOLD) {
                if (elevationDelta > 0) this.elevationGain += elevationDelta;
                else this.elevationLoss -= elevationDelta;

                this.lastElevationUsed = point.elevation;
            }

            if (point.elevation > this.maxElevation) this.maxElevation = point.elevation;
            if (point.elevation < this.minElevation) this.minElevation = point.elevation;
            if (point.latitude > this.maxLatitude) this.maxLatitude = point.latitude;
            if (point.latitude < this.minLatitude) this.minLatitude = point.latitude;
            if (point.longitude > this.maxLongitude) this.maxLongitude = point.longitude;
            if (point.longitude < this.minLongitude) this.minLongitude = point.longitude;

            const timeDelta = point.time - this.lastPoint.time;
            const currentSpeed = newDistance / timeDelta;

            if (timeDelta > 0 && this.points.length > 4) {
                const threePointsAgo = this.points[this.points.length - 3];
                const threePointAverageSpeed = point.distanceTo(threePointsAgo) / (point.time - threePointsAgo.time);

                if (threePointAverageSpeed > this.maxSpeed && currentSpeed > this.maxSpeed && currentSpeed < (2 * threePointAverageSpeed)) {
                    this.maxSpeed = threePointAverageSpeed;
                }
            }

            if (currentSpeed < STOPPED_TIME_SPEED_THRESHOLD && timeDelta > 0) {
                this.stoppedTime += timeDelta;
            }

            this.lastPoint = point;
        };

        // interval is in meters
        // culmulative prior distance is sum of all track segments before this one in the track.
        TrackSegment.prototype.getDistanceMarkers = function (interval, culmulativePriorDistance) {
            const segmentDistanceMarkers = [];
            const offsetDistance = culmulativePriorDistance % interval;
            for (let j = 1; j < this.points.length; j++) {
                const lastPoint = this.points[j - 1];
                const point = this.points[j];

                while ((offsetDistance + point.distanceFromStart) > (segmentDistanceMarkers.length + 1) * interval) {
                    const distanceToNextMarker = (segmentDistanceMarkers.length + 1) * interval - (lastPoint.distanceFromStart + offsetDistance);
                    const bearing = util.bearingBetweenDegreeCoords(lastPoint.latitude, lastPoint.longitude, point.latitude, point.longitude);
                    const nextDistanceMarker = util.destinationPoint(lastPoint.latitude, lastPoint.longitude, bearing, distanceToNextMarker);
                    segmentDistanceMarkers.push(nextDistanceMarker);
                }
            }

            return segmentDistanceMarkers;
        };


        // Puts the points into buckets and calculates average elevation per bucket to smooth values.
        // High and lows per bucket are thrown out if track is > 100 points.
        TrackSegment.prototype.calculateSmoothElevations = function () {
            if (this.points.length < 2) return;

            let bucketSize = 10;
            if (this.points.length < 10) {
                bucketSize = 1;
            } else if (this.points.length < 50) {
                bucketSize = 2;
            }
            if (this.totalTime < 10 && this.points.length < 10000) {
                bucketSize = 1;
            }
            const buffer = new DoubleBuffer(bucketSize);
            let lastUsedElevation = 0;
            this.maxSmoothElevation = MIN_ELEVATION;
            this.minSmoothElevation = MAX_ELEVATION;
            this.smoothGain = 0;
            this.smoothLoss = 0;

            for (let i = 0; i < this.points.length; i++) {
                const point = this.points[i];
                const elevation = point.elevation;
                if (elevation === 0 || elevation < MIN_ELEVATION || elevation > MAX_ELEVATION) continue;

                buffer.push(elevation);

                if (buffer.isFull) {
                    const smoothElevation = buffer.getAverage(2);
                    if (smoothElevation > this.maxSmoothElevation) this.maxSmoothElevation = smoothElevation;
                    if (smoothElevation < this.minSmoothElevation) this.minSmoothElevation = smoothElevation;

                    if (lastUsedElevation === 0) {
                        lastUsedElevation = smoothElevation;
                        continue;
                    }
                    //buffer.logBuffer();
                    const delta = smoothElevation - lastUsedElevation;

                    if (Math.abs(delta) > ELEVATION_CHANGE_THRESHOLD) {
                        if (delta > 0) this.smoothGain += delta;
                        else this.smoothLoss -= delta;
                        //console.log(smoothElevation);
                        lastUsedElevation = smoothElevation;
                    }
                }
            }
        };


        // Returns geojson simplified
        TrackSegment.prototype.getSimplifiedJson = function (tolerance) {
            const segmentJson = {};
            segmentJson['type'] = 'LineString';
            const coordinates = [];
            const simplePoints = simplifylib(this.points, tolerance, 0, false, false, false);
            for (let i = 0; i < simplePoints.length; i++) {
                coordinates.push(simplePoints[i].array3d());
            }
            segmentJson['coordinates'] = coordinates;
            return segmentJson;
        };

        TrackSegment.prototype.getGeoJson = function () {
            const segmentJson = {};
            segmentJson['type'] = 'LineString';
            const coordinates = [];
            for (let i = 0; i < this.points.length; i++) {
                coordinates.push(this.points[i].array3d());
            }
            segmentJson['coordinates'] = coordinates;
            return segmentJson;
        };

        // Returns a new TrackSegment which is simplified version of self.
        TrackSegment.prototype.simplify = function (closePointFilter, badPointFilter, stoppedFilter) {
            const simpleTS = new TrackSegment();
            if (this.totalTime < 10 && this.points.length < 10000) { // don't filter if it's a relatively short route
                return this;
            }
            const simplePoints = simplifylib(this.points, .00003, this.maxSpeed, closePointFilter, badPointFilter, this.totalTime > 10 && stoppedFilter);
            simpleTS.addPoints(simplePoints);
            return simpleTS;
        };

    }, {'../util/doublebuffer.js': 4, '../util/geoutil.js': 5, '../util/simplify.js': 6}], 3: [function (require, module, exports) {
        exports.sumFunction = function (array, field) {
            let sum = 0;
            for (let i = 0; i < array.length; i++) {
                sum += array[i][field]();
            }
            return sum;
        };


        exports.sumField = function (array, field) {
            let sum = 0;
            for (let i = 0; i < array.length; i++) {
                sum += array[i][field];
            }
            return sum;
        };


        exports.maxField = function (array, field) {
            if (array.length < 1) {
                return null;
            }

            let max = array[0][field];
            for (let i = 1; i < array.length; i++) {
                const current = array[i][field];
                if (current != null && current > max) {
                    max = current;
                }
            }
            return max;
        };


        exports.minField = function (array, field) {
            if (array.length < 1) {
                return null;
            }

            let min = array[0][field];
            for (let i = 1; i < array.length; i++) {
                const current = array[i][field];
                if (current != null && current < min) {
                    min = current;
                }
            }
            return min;
        };


        exports.pushArray = function (array, arr) {
            array.push(...arr);
        };

    }, {}], 4: [function (require, module, exports) {
        module.exports = DoubleBuffer;

        function DoubleBuffer(aSize) {
            this.index = 0;
            this.size = aSize;
            this.buffer = [];
            this.isFull = false;

        }

        DoubleBuffer.prototype.push = function (value) {
            this.buffer[this.index++] = value;
            if (this.index === this.size) {
                this.isFull = true;
                this.index = 0;
            }
        };

        DoubleBuffer.prototype.getAverage = function (trim) {
            const num = this.isFull ? this.size : this.index;
            if (num === 0) return 0;

            while (trim >= num / 2) trim--;

            let localBuffer = this.buffer;
            if (trim > 0) {
                localBuffer = this.buffer.concat().sort();
                localBuffer = localBuffer.slice(trim, num - trim);

            }
            let avg = 0;
            localBuffer.forEach(d => { avg += d / localBuffer.length; });
            return avg;
        };

        DoubleBuffer.prototype.logBuffer = function () {
            let output = '';
            for (let i = 0; i < this.buffer.length; i++) {
                if (i === this.index) {
                    output += `<<${  this.buffer[i]  }>>`;
                } else {
                    output += `[${  this.buffer[i]  }]`;
                }
            }

            output += ` avg: ${  this.getAverage(2)}`;
            console.log(output);
        };

    }, {}], 5: [function (require, module, exports) {
        const R = 6378100; // Radius of the earth in m

        exports.haversineDistance = function (lat1, lon1, lat2, lon2) {
            const dLat = deg2rad(lat2 - lat1);  // deg2rad below
            const dLon = deg2rad(lon2 - lon1);
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const d = R * c; // Distance in km
            return d;
        };


        // algorithms from http://www.movable-type.co.uk/scripts/latlong.html
        // lat, lon, bearing in radians, distance from start in meters
        exports.destinationPoint = function (latDeg, lonDeg, bearing, d) {
            const lat = deg2rad(latDeg);
            const lon = deg2rad(lonDeg);
            const destLat = Math.asin(Math.sin(lat) * Math.cos(d / R) +
                    Math.cos(lat) * Math.sin(d / R) * Math.cos(bearing));
            const destLon = lon + Math.atan2(Math.sin(bearing) * Math.sin(d / R) * Math.cos(lat),
                Math.cos(d / R) - Math.sin(lat) * Math.sin(destLat));
            return [rad2deg(destLat), rad2deg(destLon)];
        };


        // input in degrees, output in radians
        exports.bearingBetweenDegreeCoords = function (lat1, lon1, lat2, lon2) {
            return bearingBetweenCoords(deg2rad(lat1), deg2rad(lon1), deg2rad(lat2), deg2rad(lon2));
        };


        function deg2rad(deg) {
            return deg * (Math.PI / 180);
        }


        function rad2deg(rad) {
            return rad * (180 / Math.PI);
        }


        // input in radians, returns bearing in radians
        function bearingBetweenCoords(lat1, lon1, lat2, lon2) {
            const y = Math.sin(lon2 - lon1) * Math.cos(lat2);
            const x = Math.cos(lat1) * Math.sin(lat2) -
          Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
            const brng = Math.atan2(y, x);
            return brng;
        }

    }, {}], 6: [function (require, module, exports) {


        /*
 (c) 2013, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
*/


        (function () {
            'use strict';
            const Point = require('../src/point');
            // to suit your point format, run search/replace for '.longitude' and '.latitude';
            // for 3D version, see 3d branch (configurability would draw significant performance overhead)

            // square distance between 2 points
            function getSqDist(p1, p2) {

                const dx = p1.longitude - p2.longitude,
                    dy = p1.latitude - p2.latitude;

                return dx * dx + dy * dy;
            }

            // square distance from a point to a segment
            function getSqSegDist(p, p1, p2) {

                let x = p1.longitude,
                    y = p1.latitude,
                    dx = p2.longitude - x,
                    dy = p2.latitude - y;

                if (dx !== 0 || dy !== 0) {

                    const t = ((p.longitude - x) * dx + (p.latitude - y) * dy) / (dx * dx + dy * dy);

                    if (t > 1) {
                        x = p2.longitude;
                        y = p2.latitude;

                    } else if (t > 0) {
                        x += dx * t;
                        y += dy * t;
                    }
                }

                dx = p.longitude - x;
                dy = p.latitude - y;

                return dx * dx + dy * dy;
            }

            // Returns one point which is the average of the points array lat, lon, and elevation.
            // If averageTime = true, also averages time, otherwise uses time of last point
            function averagePoint(points, averageTime) {
                const len = points.length;
                if (len === 1) {
                    return points[0];
                }

                let latAvg = 0, lonAvg = 0, eleAvg = 0, timeAvg = 0;
                for (let i = 0; i < len; i++) {
                    latAvg += points[i].latitude / len;
                    lonAvg += points[i].longitude / len;
                    eleAvg += points[i].elevation / len;
                    timeAvg += points[i].time / len;
                }

                const avgPoint = new Point(latAvg, lonAvg, eleAvg, timeAvg);
                if (!averageTime) {
                    avgPoint.time = points[len - 1].time;
                }
                return avgPoint;
            }


            function simplifyStoppedTime(points, sqTolerance) {
                points = simplifyStoppedTimeStep(points, sqTolerance * 10, 30);
                points = simplifyStoppedTimeStep(points, sqTolerance * 30, 120);

                return points;
            }


            function simplifyStoppedTimeStep(points, stoppedTolerance, timeThreshold) {
                if (points.length < 3) return points;

                const n = points.length;
                let endIndex = n - 1;

                for (let i = n - 2; i >= 0; i--) {
                    const point = points[i];
                    const d = getSqDist(point, points[endIndex]);

                    if (d > stoppedTolerance || i === 0) {
                        let startIndex = i + 1;
                        if (d < stoppedTolerance) {
                            startIndex = i;
                        }
                        if (endIndex - startIndex > 2) {
                            const duration = points[endIndex].time - points[startIndex].time;
                            //console.log(startIndex + " " + endIndex + " " + (d*1E8) + " " + duration)
                            if (duration >= timeThreshold) {
                                points[startIndex].mark = true;
                                points[endIndex].mark = true;
                                points.splice(startIndex + 1, (endIndex - startIndex) - 1);

                            }
                        }
                        endIndex = i;
                    }

                }
                console.log(`stopped time: Removed ${  n - points.length  } from ${  n}`);
                return points;
            }

            // basic distance-based simplification
            // Averages together points that are within tolerance of each other
            function simplifyRadialDist(points, sqTolerance) {
                sqTolerance = 2 * sqTolerance;
                const n = points.length;
                if (n < 3) return;
                let endIndex = n - 2;

                for (let i = n - 3; i > 1; i--) {
                    const point = points[i];
                    const dv2 = getSqDist(point, points[endIndex]);

                    if (dv2 > sqTolerance || i === 1) {
                        if (dv2 < sqTolerance) i--;
                        if (endIndex - i > 1) {
                            const avgPoint = averagePoint(points.slice(i + 1, endIndex + 1), true);
                            points.splice(i + 1, (endIndex - i), avgPoint);
                        }
                        endIndex = i;
                    }

                }

                console.log(`points removed with simplifyradialdist ${  n - points.length}`);
                return points;
            }

            function simplifyDPStep(points, first, last, sqTolerance, simplified) {
                let maxSqDist = sqTolerance,
                    index;

                for (let i = first + 1; i < last; i++) {
                    if (points[i].mark) { // always pivot here if the point is marked for inclusion
                        index = i;
                        maxSqDist = 10;
                        break;
                    }

                    const sqDist = getSqSegDist(points[i], points[first], points[last]);
                    if (sqDist > maxSqDist) {
                        index = i;
                        maxSqDist = sqDist;
                    }
                }

                if (maxSqDist > sqTolerance) {
                    if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
                    simplified.push(points[index]);
                    if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
                }
            }

            // simplification using Ramer-Douglas-Peucker algorithm
            function simplifyDouglasPeucker(points, sqTolerance) {
                const last = points.length - 1;
                const simplified = [points[0]];
                simplifyDPStep(points, 0, last, sqTolerance, simplified);
                simplified.push(points[last]);
                return simplified;
            }

            function simplify(points, tolerance, maxSpeed, closePointFilter, badPointFilter, stoppedFilter) {
                if (points.length <= 2) return points;
                const sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;

                //if (badPointFilter) points = findBadPoints(points, maxSpeed);
                if (closePointFilter) points = simplifyRadialDist(points, sqTolerance);
                if (stoppedFilter) points = simplifyStoppedTime(points, sqTolerance);

                points = simplifyDouglasPeucker(points, sqTolerance);
                console.log(`simplified to ${  points.length}`);

                return points;
            }

            // export as AMD module / Node module / browser or worker variable
            if (typeof define === 'function' && define.amd) {
                define(() => simplify);
            } else if (typeof module !== 'undefined') module.exports = simplify;
            else if (typeof self !== 'undefined') self.simplify = simplify;
            else window.simplify = simplify;

        })();

    }, {'../src/point': 1}], '/src/track.js': [function (require, module, exports) {
        const arrayutil = require('../util/arrayutil.js');
        const Point = require('./point.js');
        const TrackSegment = require('./tracksegment.js');

        module.exports = Track;

        function Track() {
            this.trackSegments = [];
            this.currentTrackSegment = null;
            this.appendNewTrackSegment();

            this.distanceMarkerDistance = 0;
            this.distanceMarkers = [];
            this.distanceSinceLastMarker = 0;
        }

        Track.prototype.addGeoJson = function (geojson) {
            if (geojson['type'] === 'FeatureCollection') {
                for (let i = 0; i < geojson['features'].length; i++) {
                    const feature = geojson['features'][i];
                    this.addGeoJson(feature);
                }
            } else if (geojson['type'] === 'Feature') {
                this.addGeoJson(geojson['geometry']);

            } else if (geojson['type'] === 'MultiLineString') {
                const linestringArray = geojson['coordinates'];
                for (let i = 0; i < linestringArray.length; i++) {
                    const linestring = linestringArray[i];
                    addLinestringToTrack(linestring, this);
                }
            } else if (geojson['type'] === 'LineString') {
                addLinestringToTrack(geojson['coordinates'], this);
            }
        };

        function addLinestringToTrack(linestring, track) {
            track.appendNewTrackSegment();
            for (let i = 0; i < linestring.length; i++) {
                const coordinate = linestring[i];
                let elevation = 0;
                let time = 0;
                if (coordinate.length > 2) {
                    elevation = coordinate[2];
                }
                if (coordinate.length > 3) {
                    time = coordinate[3];
                }

                track.addPoint(new Point(coordinate[1], coordinate[0], elevation, time));
            }
        }


        // Recording status is curently to determine if track time should be [firstpoint.time, lastpoint.time] or [firstpoint.time,now]
        Track.prototype.record = function () {
            this.currentTrackSegment.recording = true;
        };

        Track.prototype.pause = function () {
            this.currentTrackSegment.recording = false;
        };

        Track.prototype.appendNewTrackSegment = function () {
            if (this.currentTrackSegment != null) {
                this.currentTrackSegment.recording = false;
            }

            if (this.currentTrackSegment === null || this.currentTrackSegment.points.length > 0) {
                this.currentTrackSegment = new TrackSegment();
                this.trackSegments.push(this.currentTrackSegment);
            }
        };

        Track.prototype.addPoint = function (point) {
            this.currentTrackSegment.addPoint(point);

            if (this.distanceMarkerDistance > 0) {
                if ((this.distanceMarkers.length + 1) * this.distanceMarkerDistance < this.distance()) {
                    this.distanceMarkers = this.getDistanceMarkers(this.distanceMarkerDistance);
                    // send new distance marker notification
                }
            }
        };

        Track.prototype.setDistanceMarkerDistance = function (newDistance) {
            if (newDistance !== this.distanceMarkerDistance) {
                this.distanceMarkerDistance = newDistance;
                if (this.distanceMarkerDistance > 0) {
                    this.distanceMarkers = this.getDistanceMarkers(this.distanceMarkerDistance);
                } else {
                    this.distanceMarkers = [];
                }
            }
        };

        Track.prototype.pointCount = function () { return this.trackSegments.reduce((sum, x) => x.points.length + sum, 0); };
        Track.prototype.distance = function () { return arrayutil.sumField(this.trackSegments, 'distance'); };
        Track.prototype.totalTime = function () { return arrayutil.sumFunction(this.trackSegments, 'trackTime'); };
        Track.prototype.stoppedTime = function () { return arrayutil.sumField(this.trackSegments, 'stoppedTime'); };
        Track.prototype.elevationGain = function () { return arrayutil.sumField(this.trackSegments, 'elevationGain'); };
        Track.prototype.elevationLoss = function () { return arrayutil.sumField(this.trackSegments, 'elevationLoss'); };

        Track.prototype.averageSpeed = function () { return this.distance() / this.totalTime(); };
        Track.prototype.movingTime = function () { return this.totalTime() - this.stoppedTime(); };
        Track.prototype.movingSpeed = function () { return this.distance() / this.movingTime(); };

        Track.prototype.maxSpeed = function () { return arrayutil.maxField(this.trackSegments, 'maxSpeed'); };
        Track.prototype.maxElevation = function () { return arrayutil.maxField(this.trackSegments, 'maxElevation'); };
        Track.prototype.minElevation = function () { return arrayutil.minField(this.trackSegments, 'minElevation'); };

        Track.prototype.maxLatitude = function () { return arrayutil.maxField(this.trackSegments, 'maxLatitude'); };
        Track.prototype.minLatitude = function () { return arrayutil.minField(this.trackSegments, 'minLatitude'); };
        Track.prototype.maxLongitude = function () { return arrayutil.maxField(this.trackSegments, 'maxLongitude'); };
        Track.prototype.minLongitude = function () { return arrayutil.minField(this.trackSegments, 'minLongitude'); };

        Track.prototype.smoothGain = function () { return arrayutil.sumField(this.trackSegments, 'smoothGain'); };
        Track.prototype.smoothLoss = function () { return arrayutil.sumField(this.trackSegments, 'smoothLoss'); };
        Track.prototype.maxSmoothElevation = function () { return arrayutil.maxField(this.trackSegments, 'maxSmoothElevation'); };
        Track.prototype.minSmoothElevation = function () { return arrayutil.minField(this.trackSegments, 'minSmoothElevation'); };

        Track.prototype.lastPoint = function () { return this.currentTrackSegment.lastPoint; };


        Track.prototype.getDistanceMarkers = function (interval) {
            const distanceMarkerPoints = [];
            let offsetDistance = 0; // culmulative distance of earlier track segments
            for (let i = 0; i < this.trackSegments.length; i++) {
                const track = this.trackSegments[i];
                if (track.lastPoint) {
                    arrayutil.pushArray(distanceMarkerPoints, track.getDistanceMarkers(interval, offsetDistance));
                    offsetDistance += track.lastPoint.distanceFromStart;
                }
            }
            this.distanceSinceLastMarker = offsetDistance;
            return distanceMarkerPoints;
        };


        Track.prototype.getJsonStats = function () {

            let finalPoint = null;  // keep track of last point in case last tracksegment is empty
            for (let i = 0; i < this.trackSegments.length; i++) {
                const trackSegment = this.trackSegments[i];
                trackSegment.calculateStats();

                if (trackSegment.lastPoint) {
                    finalPoint = trackSegment.lastPoint;
                }
            }

            const jsonStats = {};
            if (finalPoint != null) {
                jsonStats['final_point'] = finalPoint.getJson();
            }
            jsonStats['distance'] = this.distance();
            jsonStats['total_time'] = this.totalTime();
            jsonStats['moving_time'] = this.movingTime();
            jsonStats['stopped_time'] = this.stoppedTime();
            jsonStats['max_elevation'] = this.maxElevation();
            jsonStats['min_elevation'] = this.minElevation();
            jsonStats['ascent'] = this.elevationGain();
            jsonStats['descent'] = this.elevationLoss();
            jsonStats['moving_speed'] = this.movingSpeed();
            jsonStats['average_speed'] = this.averageSpeed();

            jsonStats['max_speed'] = this.maxSpeed();

            jsonStats['max_latitude'] = this.maxLatitude();
            jsonStats['min_latitude'] = this.minLatitude();
            jsonStats['max_longitude'] = this.maxLongitude();
            jsonStats['min_longitude'] = this.minLongitude();
            jsonStats['distance_markers_points'] = this.distanceMarkers;
            jsonStats['distance_markers'] = this.getDistanceMarkers(1000);
            jsonStats['max_smooth_elevation'] = this.maxSmoothElevation();
            jsonStats['min_smooth_elevation'] = this.minSmoothElevation();
            jsonStats['ascent'] = this.smoothGain();
            jsonStats['descent'] = this.smoothLoss();
            jsonStats['segment_count'] = this.trackSegments.length;
            jsonStats['point_count'] = this.pointCount();

            jsonStats['current_segment_start_date'] = this.currentTrackSegment.startTime;
            jsonStats['prior_segments_time'] = this.totalTime() - this.currentTrackSegment.trackTime();

            return jsonStats;
        };

        Track.prototype.getSimplifiedJson = function (tolerance) {
            return this.getGeoJson(tolerance);
        };

        Track.prototype.getGeoJson = function (tolerance) {
            const geojson = {};
            geojson['type'] = 'FeatureCollection';
            const features = [];
            for (let i = 0; i < this.trackSegments.length; i++) {
                const trackSegment = this.trackSegments[i];
                const feature = {};
                feature['type'] = 'Feature';
                if (tolerance && tolerance > 0) {
                    feature['geometry'] = trackSegment.getSimplifiedJson(tolerance);
                } else {
                    feature['geometry'] = trackSegment.getGeoJson();
                }
                features.push(feature);
            }

            geojson['features'] = features;

            return geojson;
        };


        // This function simplifies the track data. It is destructive.
        Track.prototype.simplify = function (closePointFilter, badPointFilter, stoppedFilter) {
            for (let i = 0; i < this.trackSegments.length; i++) {
                const ts = this.trackSegments[i];
                this.trackSegments[i] = ts.simplify(closePointFilter, badPointFilter, stoppedFilter);
                this.trackSegments[i].recording = ts.recording;
            }
            this.currentTrackSegment = this.trackSegments[this.trackSegments.length - 1];
        };

        // Filters track. Destroys remvoed points.
        Track.prototype.filter = function () {
            this.simplify(true, true, true);
        };

    }, {'../util/arrayutil.js': 3, './point.js': 1, './tracksegment.js': 2}]}, {}, [])('/src/track.js');
});
